import { Row, Col, Spin, message } from "../../ui/ot";
import { useState, useEffect } from 'react';
import { lazy } from 'react';
import { Suspense } from 'react';
import { useSearchParams } from "react-router-dom";
import { usePageManagement } from '../controller/page_management_controller'
import { useBackground } from '../../component_layout/BackgroundContext'

const PreviewPage = ({

}) => {
    const [searchParams] = useSearchParams()
    const { page_id } = Object.fromEntries([...searchParams])
    const [pageContainerData, setPageContainerData] = useState([]);
    const [permissionData, setPermissionData] = useState({});
    const { setBackgroundImage } = useBackground();

    const [loading, setLoading] = useState(false)
    const {
        PageManagementData,
        getPageManagementData,
    } = usePageManagement({
        onFinish: ({ axiosMode, status, values }) => {
            if (axiosMode === 'patch') {
                if (status === "success") {
                    if (axiosMode === "post") {
                        message.success("新增成功");
                    } else if (axiosMode === "patch") {
                        message.success("修改成功");
                    } else if (axiosMode === "delete") {
                        message.success("刪除成功");
                    }
                } else if (status === "error") {
                    if (axiosMode === "post") {
                        message.error("新增失敗");
                    } else if (axiosMode === "patch") {
                        message.error("修改失敗");
                    } else if (axiosMode === "delete") {
                        message.error("刪除失敗");
                    }
                }
                getPageManagementData({
                    page_id
                }, true)
            }
        },
        onBefore: ({ axiosMode, status }) => { },
    });
    useEffect(() => {
        if (page_id) {
            getPageManagementData({
                page_id: page_id,
            }, true);
        }
    }, [page_id]);
    useEffect(() => {
        let firstData = (PageManagementData || []).find((ele) => true);
        if (firstData) {
            let page_menu_data = (firstData?.page_menu_data || []).map(
                (value) => {
                    return value?.menu_id
                }
            );
            let permission_page_data = (
                firstData?.permission_page_data || []
            ).map((value) => {
                return value?.permission_id
            });

            setPageContainerData(() => {
                return firstData?.frontend_component_blog_type_data || [];
            });
            setBackgroundImage(firstData?.property_json?.backgroundImage || '');
        }
    }, [PageManagementData]);
    return <Row>
        <Col span={24}>
            <>
                {loading ?
                    <>
                        <Spin />
                    </>
                    :
                    <>
                        {/* MainPage */}
                        {/* <EMILayout> */}
                        <Row justify={'center'} gutter={[8, 16]} >
                            {permissionData?.show === 1 && <>
                                <Col span={24}>
                                    <Row
                                        justify={'center'}
                                        align="middle"
                                        style={{
                                            backgroundImage: `linear-gradient(to right, ${permissionData?.property_json?.background_color1}, #ffffff,${permissionData?.property_json?.background_color2})`, padding: '10px',
                                            position: 'relative',
                                        }}>
                                        <Col style={{ textAlign: 'center' }}>
                                            {console.log(permissionData)}
                                            <span style={{
                                                fontSize: permissionData?.property_json?.size ? permissionData.property_json.size : "3vmin",
                                                fontWeight: permissionData?.property_json?.blod ? 900 : "normal",
                                                fontStyle: permissionData?.property_json?.italic ? "italic" : "normal",
                                                textDecoration: permissionData?.property_json?.textDecoration ? "underline" : "none"
                                            }}>
                                                {permissionData.name}
                                            </span>
                                        </Col>
                                        {/* <Col style={{ position: 'absolute', left: '90%', top: '0%' }}>
                                                                            <Button className='example' size='large' shape="circle" icon={<EditOutlined />} style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#F9D4E5' }} onClick={e => set_open_wyswyg(true)} />
                                                                        </Col> */}
                                    </Row>
                                </Col>
                                {/* 副標題 */}
                                {/* <Col span={24}>
                                <Row gutter={[40, 16]} justify="center" align="middle" style={{ margin: '10px' }}>
                                    <Col md={{ span: 6 }} sm={{ span: 24 }}>
                                        <Row gutter={[8, 8]}>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                                        </Row>
                                    </Col>
                                    <Col md={{ span: 8 }} sm={{ span: 24 }} >
                                        <Row justify={'center'}>
                                            <Col >
                                                <span dangerouslySetInnerHTML={{ __html: permissionData.subheading }}></span>
                                            </Col>
                                        </Row>

                                    </Col>
                                    <Col md={{ span: 6 }} sm={{ span: 24 }} style={{ position: 'relative' }}>
                                        <Row gutter={[8, 8]}>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col> */}
                            </>}

                            {/* <Col span={24}>
                            {marquee_color && <>
                                <Marquee style={{ height: '2em', backgroundColor: `rgba(${marquee_color.r}, ${marquee_color.g}, ${marquee_color.b}, ${marquee_color.a})`, fontSize: '2vh' }} speed={marquee_speed}>
                                    <NotificationFilled />{marquee_text}
                                </Marquee>
                            </>}
                            <Carousel_news_ticker
                                height={'20vh'}
                            />
                        </Col> */}
                            {/* {console.log(pageContainerData)} */}
                            {
                                (pageContainerData || [])?.map((rowData, rowIndex) => {
                                    return (
                                        rowData?.page_frontend_row_data
                                            ?.map((columnData, columnIndex) => {
                                                if (!rowData.frontend_row_hidden) {
                                                    return (
                                                        columnData?.frontend_row_frontend_column_data?.map((componentData, componentIndex) => {
                                                            return (
                                                                <Col span={24}>

                                                                    {/* <Row gutter={[10, 20]} justify="space-around"> */}
                                                                    {componentRender(componentData.frontend_component_name, componentData.frontend_column_frontend_component_blog_type_data)}
                                                                    {/* </Row> */}

                                                                </Col>
                                                            )
                                                        })
                                                    )
                                                }

                                            })
                                    )
                                })
                            }
                        </Row>
                        {/* </EMILayout> */}
                    </>
                }
            </>

        </Col>
    </Row>
}
const componentRender = (component_name, blogTypeData) => {
    const Component = lazy(() => import(`../components/${component_name}`))
    console.log(blogTypeData)
    if (blogTypeData.length !== 0) {
        return (
            <Suspense fallback={<></>}>
                <Component
                    blogTypeData={blogTypeData}
                />
            </Suspense>
        )
    }
    else {
        return (
            <Suspense fallback={<></>}>
                <Component
                // blogTypeData={blogTypeData}
                />
            </Suspense>
        )
    }
}
export default PreviewPage